import React from 'react';
import loadable from '@loadable/component';

import CompareDrawer from '../compare/components/compare-drawer';
import withPage, { loadGraphQLData } from '../page';

const HomePage = loadable(() => import('./components'));

const HomeContainer = ({ slugInfo = {} }) => {
    const { featuresTabHtml, productTab = {} } = slugInfo.components || {};
    const [productGroup = {}] = productTab.productGroups || [];
    const { productsList = [] } = productGroup || {};
    return (
        <>
            <HomePage />
            <CompareDrawer />
        </>
    );
};

export default {
    component: withPage(HomeContainer, {
        wrapperClassName: 'home-root',
        showWordCloud: true,
        useGraphQL: true,
        useV2: true,
        noProps: true,
    }),
    loadData: loadGraphQLData,
};
